import { Component, Watch, Prop, Mixins, Vue } from 'vue-property-decorator';
import {validationMixin, Validation} from "vuelidate";
import UserMixin from "./UserMixin";
import EventEntryModel from "../../models/EventEntryModel";

@Component({
  mixins: [validationMixin]
})
export default class FormStep extends Mixins(UserMixin) {
  @Prop() readonly entry!: EventEntryModel | null;
  @Prop({default: () => { return {} }}) errors!: Record<string,string>;
  @Prop({default: false}) disabled!: boolean;

  formError(key: string, error: string): string {
    if (this.$v.form && this.$v.form[key]) {
      if ((this.$v.form[key] as Validation).$anyError) {
        return error;
      }
    }

    if (this.errors[key]) {
      return this.errors[key];
    }

    return '';
  }

  mounted(): void {
    if (this.entry) {
      this.runValidation(!this.entry.isSaved());
    }
  }

  runValidation(silent = false): void {
    if (!this.$v) {
      return;
    }
    this.$v.$touch();
    this.$emit('valid', !this.$v.$invalid);

    if (silent) {
      this.$v.$reset();
    }
  }

  get disabledDivision(): boolean {
    return this.disabled;// || this.entry?.isPaid() ? true : false;
  }

  get userIsEntryCreator(): boolean {
    return this.user.data.id === this.entry?.data.user_id;
  }

  @Watch('$v.$invalid')
  watchFormChanges(): void {
    if (this.$v.$anyDirty) {
      this.$emit('valid', !this.$v.$invalid);
    }
  }

}
